import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import axios from 'axios';
import DashboardView from './DashboardView';
import TranslationView from './TranslationView';
import Download from '../../components/styled/Download';
import { saveAs } from 'file-saver';
import TableView from './TableView';
import { toast } from 'react-toastify';
import TranslationTable from '../TranslationTable';


const Tasks = () => {
    const { API_URL } = useContext(GlobalContext);
    const [data, setData] = useState([]);
    const [extractedText, setExtractedText] = useState('');
    const [imageName, setImageName] = useState([]);
    const [editedText, setEditedText] = useState('');
    // eslint-disable-next-line
    const [isLoading, setIsLoading] = useState({});
    const [isLoadingArchive, setIsLoadingArchive] = useState({});
    // eslint-disable-next-line
    // const [textViewSave, setTextViewSave] = useState([]);
    const [translatedText, setTranslatedText] = useState([])
    const [viewedRowIndex, setViewedRowIndex] = useState('')
    const [folderDir, setFolderDir] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [postsPerPage, setPostsPerPage] = useState(10);
    const [isArchive, setIsArchive] = useState(false)
    const [isEditing, setIsEditing] = useState(false);
    // eslint-disable-next-line
    const [textViewSave, setTextViewSave] = useState([]);

    // eslint-disable-next-line
    const [loading, setLoading] = useState(false);
    const storedData = JSON.parse(localStorage.getItem('avatarUser'));
    const authTokenAccess = storedData ? storedData?.access_token : null


    const getTableData = async (page, postsPerPage) => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_URL}/api/tasks?page=${page}&size=${postsPerPage}`, { "token": authTokenAccess }, {
                headers: {
                    "Content-Type": "application/json",
                    // Authorization: `Bearer ${authTokenAccess}`,
                },
            });
            if (response && response.data) {
                setData(response.data.data);
                setTotalPages(response.data.totalPages);
                console.log("get Data", response.data);
            } else {
                console.log("Response data is missing or invalid");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        getTableData(currentPage, postsPerPage);
        // eslint-disable-next-line
    }, [currentPage, postsPerPage]);


    const handleSubmit = async (event, taskname, index) => {
        event.preventDefault();

        setImageName([]);
        setExtractedText("");
        setEditedText("");
        setTranslatedText([]);
        setFolderDir("");
        setIsArchive("")

        setIsLoading({ ...isLoading, [taskname]: true });
        setViewedRowIndex(index);
        const formData = new FormData();
        formData.append('taskname', taskname);

        try {
            const response = await axios.post(`${API_URL}/api/dashboard`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.filename && response.status === 200) {
                setImageName(response.data.filename);
                setExtractedText(response.data.text);
                setEditedText(response.data.text);
                setTranslatedText(response.data.data);
                setFolderDir(response.data.folderDir);
                setIsArchive(Number(response.data.isArchive) === 1);
            }
            console.log("response Tasks:", response.data);


            if (response.data.message) {
                alert('The requested file does not exist.');
            }
        } catch (error) {
            console.error('Error Connection:', error);
        } finally {
            console.log("Finally....");
            setIsLoading({ ...isLoading, [taskname]: false });
        }
    };


    const handleArchive = async (event, taskname, index) => {
        event.preventDefault();
    
        setIsLoadingArchive({ ...isLoading, [taskname]: true });
        setViewedRowIndex(index);
    
        try {
            const response = await axios.post(`${API_URL}/api/archive-data`, { "taskname": taskname });
      
            if (response.data && response.status === 200) {
                getTableData(currentPage, postsPerPage);
                toast.success(response.data.message);
            } else if (response.data && response.data.message) {
                toast.error(response.data.message);
            }
    
        } catch (error) {
            console.error('Error Connection:', error);
            if (!error.response) {
                toast.error("Network error. Please check your connection.");
                return;
            }
    
            toast.error(error.response.data?.message || "Something went wrong");
        } finally {
            console.log("Finally....");
            setIsLoadingArchive({ ...isLoading, [taskname]: false });
        }
    };

    const handleDownload = () => {
        const nanoTimestampFile = Date.now() * 1_000_000;
        const tsvString = translatedText.map(row => `${row.srctxt}\t${row.tgttxt}`).join('\n');
        const blob = new Blob([tsvString], { type: 'text/tab-separated-values' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${nanoTimestampFile}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };


    const downloadTranslatedDocxFile = () => {
        const formattedData = translatedText.map(row => `${row.srctxt}\t${row.tgttxt}`).join('\n');
        const blob = new Blob([formattedData], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });

        let fileName = "";

        if (typeof imageName === 'string') {
            // Assuming the imageName is a filename with an extension, e.g., "example.docx"
            const fileNameParts = imageName.split('.');
            fileNameParts.pop(); // Remove the file extension
            fileName = fileNameParts.join('.') + '.docx';
        } else {
            console.error('selectedImage is not a string...');
            return; // Exit the function if selectedImage is not a valid string
        }

        saveAs(blob, fileName);
    };

    const handleEditClick = () => { setIsEditing(true) };
    const handleSaveClick = async () => {
        setIsEditing(false);
        setTextViewSave(editedText);

        try {
            const response = await axios.post(`${API_URL}/api/textViewSave`, { "text": editedText, "taskname": imageName, "folderDir": folderDir }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data && response.status === 200) {
                toast.success(response.data.response);
                console.log("response Tasks:", response.data.response);
            }

        } catch (error) {
            console.error('Error Connection:', error);
            // Handle the error, e.g., display an error message to the user.
        } finally {
            console.log("Finally....");
        }
    };

    return (
        <>
            {Array.isArray(data) && data.length > 0 ? (
                <TableView data={data} setCurrentPage={setCurrentPage} handleSubmit={handleSubmit} handleArchive={handleArchive} totalPages={totalPages} viewedRowIndex={viewedRowIndex} isLoading={isLoading} isLoadingArchive={isLoadingArchive} currentPage={currentPage} setPostsPerPage={setPostsPerPage} postsPerPage={postsPerPage} isArchive={data} />
            ) : (
                <table className="w-full mt-2">
                    <tr>
                        <td className="border border-gray-300 py-3 text-xl text-center" colSpan="3">No Task available</td>
                    </tr>
                </table>
            )}

            {extractedText.length > 0 ? (
                <div>
                    <div>
                        <DashboardView
                            API_URL={API_URL}
                            imageName={imageName}
                            folderDir={folderDir}
                            editedText={editedText}
                            setEditedText={setEditedText}
                            isArchive={isArchive}
                            isEditing={isEditing}
                            handleEditClick={handleEditClick}
                            handleSaveClick={handleSaveClick}

                        />
                    </div>
                </div>
            ) : ""
            }

            {translatedText.length > 0 ?
                <div className='container mt-5 mb-5'>
                    <div className='container flex flex-wrap mt-2 border-t-2 border-blue-100'></div>
                    <div className="flex">
                        <h1 className="text-3xl text-center h-10 rounded-full text-slate-800 bg-blue-300 font-bold mb-4 border border-blue-300 -ml-5 w-10 border-t-0">4</h1>
                        <span className='text-4xl ml-2 font-bold text-slate-800'>Translation</span>
                    </div>

                    <div className='ml-6 -mt-14'>
                        {isArchive ?
                            <div>
                                <div className="text-right">
                                    <Download linkTitletxt="Translation Text (.txt)" linkTitleDocs="Translation Text (.docx)" handleDownload={handleDownload} downloadDocxFile={downloadTranslatedDocxFile} />
                                </div>
                                <TranslationView data={translatedText} />
                            </div>
                            :
                            <TranslationTable data={translatedText} selectedImage={imageName} folderDir={folderDir} />
                        }
                    </div>
                </div>
                : ""}
        </>
    );
};

export default Tasks;
